/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Deep_TitleInputs */

const en_to_csv_deep_title = /** @type {(inputs: To_Csv_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoting rules and the two things Excel will argue with`)
};

const ko_to_csv_deep_title = /** @type {(inputs: To_Csv_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용 규칙과 Excel이 시비를 걸 두 가지`)
};

const ja_to_csv_deep_title = /** @type {(inputs: To_Csv_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用の規則と、Excel が文句を言う 2 点`)
};

/**
* | output |
* | --- |
* | "Quoting rules and the two things Excel will argue with" |
*
* @param {To_Csv_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_deep_title = /** @type {((inputs?: To_Csv_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_deep_title(inputs)
	if (locale === "ko") return ko_to_csv_deep_title(inputs)
	return ja_to_csv_deep_title(inputs)
});